<template>
  <div>

    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">Number Series</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>
      <!-- <v-btn round-borders outline @click="fn_new">New</v-btn> -->
      <!-- <v-btn icon @click="fn_getBottomMenu"><v-icon>more_vert</v-icon></v-btn> -->

      <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
    </v-toolbar>

    <div class="display_msg" v-if="!filteredItems.length">No Items</div>

    <div style="background-color:#F0F0F0;" class="hasToolbar hasExtension">
      <v-list nopadding>
        <div v-for="(item, index) in filteredItems" :key="index">
          <v-list-tile @click="fn_itemClick(item.numberSeriesId)">
            <v-list-tile-content>
              <v-list-tile-title>{{item.name}}</v-list-tile-title>
              <!-- <v-list-tile-sub-title>{{item.fieldType.title}}</v-list-tile-sub-title> -->
            </v-list-tile-content>  
          </v-list-tile>
          <v-divider v-if="filteredItems.length-1 != index"></v-divider>
        </div>
      </v-list> 
    </div>
  </div>
</template>

<script>
var tagId = null;
const menuItem = require('../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../config.js').configs.bottomSheetMenu;

  export default{
    data(){
      return{
        listItems:[],
        searchValue:'',
        scrollPositionTop:0
      }
    },
    methods:{
      fn_new: function () {
        this.$router.push({path:"/numberseries/items/new", query:{tagId:this.guidWeb()}});
      },

      fn_goBack: function(){
        this.$router.go(-1);
      },

      fn_menuItemClick: function(tagId, menuId, menuAction){
        // tagId id form future use
        // menuId id form future use
        if(menuAction=='new'){
          this.fn_new();
        }
      },

      fn_itemClick: function (itemId) {
        // tagId id form future use
        // itemName id form future use
        this.$router.push("/numberseries/items/"+itemId+"/edit");
      },

      // fn_getBottomMenu: function () {

      //   let bottomMenu = {"BottomMenu": [menuItem.help]};

      //   this.setBottomMenu(tagId, bottomMenu, 
      //     {
      //       onSuccess: function (response) {
      //         console.log(response);
      //       },
      //       onError: function (error) {
      //         console.log(error);
      //       }
      //     }
      //   )
      // },


      fn_getItems: function () {
        let filterObject = {};

        let self = this;
        this.getItems("NumberSeriesList", filterObject, 
          {
            onSuccess: function (response) {
              console.log(response);
              self.listItems = JSON.parse(response);
            },
            onError: function (error) {
              console.log(error);
            }
          }
        )
      },

      fn_showWebView: function () {
        var viewObject = {};
        var self = this;
        this.showWebView(tagId, viewObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null,
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.fn_menuItemClick(tagId, menuId, menuAction)
            } 
          }
        );
      },
    },
    mounted: function () {
      tagId = this.$route.query.tagId;

      this.fn_showWebView();
      this.fn_getItems();
      window.js_globals.fn_onBackPress = this.fn_goBack;

      let self = this;
      document.addEventListener('scroll', function () {
        self.scrollPositionTop = window.pageYOffset
      })
    },
    computed:{
      filteredItems: function () {
        let searchText = this.searchValue.toLowerCase();

        return this.listItems.filter(item => {
          let fieldItem = item.name.toLowerCase();
          return fieldItem.match(searchText);
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/number_series/items.vue